import React from 'react'
import { Grid } from "@mui/material"
import SectionDivider from "../SectionDivider"
import SelectorWithSkeleton from "../SelectorSkeleton"
import UserNameField from "./UserName"
import UserPasswordField from "./Password"
import UserEmailField from "./Email"
import UserExpirationDateField from "./ExpirationDate"
import UserTimeZoneField from "./UserTZ"
import UserCurrencyField from "./Currency"
import UserCompanyField from "./Company"

export default function UserInfoSection({ isLoading }) {


	return <Grid container spacing={2}>
		<Grid item>
			<SectionDivider title="User Info" icon="circle-info"/>
		</Grid>
		<Grid item xs={12}/>
		<SelectorWithSkeleton isLoading={isLoading} SelectorComponent={UserNameField} xs={3.5}/>
		<SelectorWithSkeleton isLoading={isLoading} SelectorComponent={UserPasswordField} xs={3.5}/>
		<SelectorWithSkeleton isLoading={isLoading} SelectorComponent={UserEmailField} xs={5}/>
		<SelectorWithSkeleton isLoading={isLoading} SelectorComponent={UserExpirationDateField} xs={4}/>
		<SelectorWithSkeleton isLoading={isLoading} SelectorComponent={UserTimeZoneField} xs={4}/>
		<SelectorWithSkeleton isLoading={isLoading} SelectorComponent={UserCurrencyField} xs={4}/>
		<SelectorWithSkeleton isLoading={isLoading} SelectorComponent={UserCompanyField} xs={6}/>
	</Grid>
}